export default function playAudio(fileName: string) {
    return new Audio(fileName).play();
}
